<template>
    <div>
        <!-- filters -->
        <v-row class="my-auto">
            <v-col cols="auto" class="">
                <v-autocomplete 
                    v-model="teamId"
                    :items="teams"
                    item-text="name"
                    item-value="id"
                    hide-details
                    dense
                    outlined
                    label="Team"
                    :disabled="loading || submitLoading"
                    :loading="loading || submitLoading"
                    clearable
                />
            </v-col>   

            <v-col cols="auto">
                <bee-date-input
				    v-model="date"
				    :label="$t('inputs.date')"
				    :loading="loading"
                    :disabled="loading || submitLoading"
                    dense
                    hide-details
                    input-format-order="year-month-day"
                    input-type="month"
                    :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'"
                    :prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'"
                    readonly
                    fit-inputs
                    @click:append="nextMonth()"
                    @click:prepend="prevMonth()"
			></bee-date-input>
            </v-col>

            <!-- <v-spacer /> -->
            <v-col class="d-flex " align-self="center">
                <v-btn
                    color="success"
                    class="px-sm-4 mx-2"
                    :loading="loading"
                    :disabled="loading || !teamId || submitLoading"
                    small
                    @click="isSearch = true; transactionEmployeeTeam = []; getTeamById()"
                >
                    <v-icon size="15" class="me-1"> mdi-magnify </v-icon>
                    {{$t('search')}}
                </v-btn>
                <v-btn
                    v-if="isPreview"
                    color="edit-color white--text"
                    class="px-sm-4 mx-2"
                    :loading="loading"
                    :disabled="loading || !teamId || submitLoading"
                    small
                    @click="isPreview = false"
                >
                    <v-icon size="15" class="me-1"> mdi-pencil </v-icon>
                    {{ $t('edit') }}
                </v-btn>
            </v-col>
        </v-row>
        <!-- table expander -->
        <bee-handy-table
            :headers="headers"
            :items="specialtiesByTeam"
            dense
            zebra
            :loading="loading"
            :data-table-props="{
                singleExpand: true,
				expandedSync: expanded,
				showExpand: true,
                disableSort: true,
                itemKey: 'id'
			}"
            :items-per-page="-1"
            pagination-on-scroll
            :height="$vuetify.breakpoint.height - 170"
        >
        <!-- materialsForTable -->
            <template v-slot:expanded-item="{ item }">
                <td colspan="12" class="tab" >
                    <bee-handy-table
                        v-model="tableInputs[index]"
                        :headers="headersMaterials"
                        :items="item.materialsForTable"
                        zebra
                        dense
                        hide-default-footer
                        :items-per-page="-1"
                        width="100%"
                    >
                    </bee-handy-table>
                </td>
            </template>
        </bee-handy-table>
        <!-- Expander -->
        <v-expansion-panels v-if="0" v-model="expanderSpecialty" multiple>
            <v-expansion-panel
                v-for="(item,index) in specialtiesByTeam"
                :key="index"
                style="background-color: #f5f5f5;"
            >
                <v-expansion-panel-header>
                    {{ item.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <!-- {{ tableRefs$refs.table }} -->
                        <!-- :ref="el => setTableRef(el, item.specialtyId)"   -->
                    <bee-handy-smart-table
                        v-model="tableInputs[index]"
                        :headers="headers"
                        :items="item.materialsForTable"
                        zebra
                        dense
                        hide-default-footer
                        :show-add-row="!loading || !submitLoading"
                        editable-rows
                    >
                        <template v-slot:input.materialId="{ on, attr }">
                            <v-autocomplete 
                                :items="[]"
                                item-text="name"
                                item-value="id"
                                dense
                                v-on="on"
                                v-bind="attr"
                            />
                        </template>

                        <template v-slot:input.workLoadId="{ on, attr}">
                            <v-autocomplete 
                                :items="classification"
                                item-text="name"
                                item-value="id"
                                dense
                                v-on="on"
                                v-bind="attr"
                            />
                        </template>

                        <template v-slot:item.action="{ item ,index }">
                            <div>
                                <!-- edit -->
                                <tooltip :text="$t('edit')" top>
                                    <v-btn
                                        icon
                                        small
                                        color="success"
                                        class="me-2"
                                        @click="() => {
                                            $refs.table.activeEditForRow(index);
                                            editRowIndex = index;
                                            isEdit = true
                                        }"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </tooltip>

                                <!-- delete -->
                                <tooltip :text="$t('delete')" top>
                                    <v-btn
                                        icon
                                        small
                                        color="red lighten-1"
                                        @click="deleteItem(item.id)"
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </tooltip>
                            </div>
                        </template>

                        <template v-slot:no-input.action>
                            <div class="d-flex justify-center">
                                <v-btn
                                    icon
                                    small
                                    color="success"
                                    :disabled="loading"
                                    @click="isEdit ? editItem(index) : addItem(index)"
                                >
                                    <v-icon>
                                        mdi-check-circle-outline
                                    </v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </bee-handy-smart-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import moment from 'moment' 
import { mapGetters, mapState } from 'vuex'
import Tooltip from '@/components/Tooltip.vue'
import rules from '@/validation rules'
export default {
    name: 'Material-plan',

    components: {
        Tooltip
    },

    data () {
        return {
            teamId: null,
            date: moment().format('YYYY-MM-DD'),
            loading: false,
            submitLoading: false,
            isPreview: false,
            isSearch: false,
            transactionEmployeeTeam: [],
            items: [],
            rules,
            tableInputs: {},
            isEdit: false,
            testArray: [],
            specialtiesByTeam: [],
            expanderSpecialty: 0,
            editRowIndex: null,
            expanded: null
        }
    },

    computed: {
        ...mapState({
            teams: state => state.teams.teams,
            specialties: state => state.specialties.specialties,
            materials: state => state.materials.materials,
            staff: state => state.accounts.staff,
            employeeId: state => state.auth.self.employeeId,
            myMaterials: state => state.materials.myMaterials,
            classification: state => state.workload.classification
        }),

        ...mapGetters({
            getSpecialtyById: 'specialties/getSpecialtyById',
            getMaterialById: 'materials/getMaterialById',
            getClassificationById: 'workload/getClassificationById'
        }),

        headers () {
            return [
                {
                    text: this.$t('headers.specialty'),
                    name: 'name',
                    value: 'name',
                    width: '100%'
                    // setValueExpr: val => this.getSpecialtyById(val)?.name
                },
            ]
        },

        headersMaterials() {
            return [
                {
                    text: this.$t('headers.item'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: this.$t('headers.class'),
                    name: 'workloadId',
                    value: 'workloadId',
                    setValueExpr: val => this.getClassificationById(val)?.name
                },
                {
                    text: this.$t('headers.amount'),
                    name: 'amount',
                    value: 'amount',
                    type: "number"
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes',
                    width: "40%"
                },
                {
                    text: '',
                    name: 'action',
                    value: 'action',
                    noInput: true,
                    sortable: false
                }
            ]
        }
    },

    methods: {
        moment,
        // async getTeamById () {
        //     this.loading = true
        //     this.items = []
        //     this.isPreview = false

        //     try {
        //         const team = this.teams.find(c => c.id === this.teamId)
        //         if (!team) return

        //         // جلب البيانات المطلوبة بشكل متوازٍ
        //         const [materialsForSpecialties, teamMaterials] = await Promise.all([
        //             this.$store.dispatch('materials/fetchMaterialForSpecialties', { specialtyIds: team.specialtyIds }),
        //             this.$store.dispatch('materials/fetchMaterialsTeams', { 
        //                 teamId: this.teamId, 
        //                 fromDate: moment(this.date).startOf('month').format('YYYY-MM-DD'), 
        //                 toDate:  moment(this.date).endOf('month').format('YYYY-MM-DD') 
        //             })
        //         ])

        //         this.materialsWithSpe = materialsForSpecialties // لتعبئة حقول الإكمال التلقائي

        //         // بناء هيكل البيانات الصحيح الذي يتوقعه القالب
        //         this.items = team.specialtyIds.map(specId => {
        //             const materialsForThisSpecialty = teamMaterials.filter(m => m.specialtyId === specId)
        //             console.log('materialsForThisSpecialty', materialsForThisSpecialty?.teamSpecialtiesMaterials)
        //             // تنسيق البيانات لتناسب الجدول
        //             // const tableData = materialsForThisSpecialty.teamSpecialtiesMaterials.map(material => ({
        //             //     id: material.id,
        //             //     materialId: material.materialId,
        //             //     class: material.workloadId,
        //             //     amount: material.amount,
        //             //     notes: material.notes
        //             // }))

        //             return {
        //                 specialtyId: specId,
        //                 materialsForTable: materialsForThisSpecialty
        //                 // materialsForTable: tableData // هذه البيانات سترسل إلى الجدول
        //             }
        //         })

        //         if (teamMaterials.length > 0) {
        //             this.isPreview = true
        //         }
        //     } catch (error) {
        //         console.error("Error fetching team materials:", error)
        //     } finally {
        //         this.loading = false              
        //     }
        // },
 
        getTeamById () {
            this.loading = true
            this.items = []
            this.specialtiesByTeam = []
            this.isPreview = false

            const team = this.teams.find(c => c.id === this.teamId)
            this.isempty = false

            this.$store.dispatch('materials/fetchMaterialForSpecialties', { specialtyIds: team.specialtyIds }).then((data) => {
                // store materials with specialty
                this.materialsWithSpe = data
            }).then((data) => {
                // this.endpoint change when upload api
                this.$store.dispatch('materials/fetchMaterialsTeams', { 
                    teamId: this.teamId, 
                    fromDate: moment(this.date).startOf('month').format('YYYY-MM-DD'),
                    toDate: moment(moment(this.date).endOf('month')).format('YYYY-MM-DD') 
                }).then((data) => {
                    this.specialtiesByTeam = team.specialtyIds.map(c => ({
                        name: this.specialties.find(g => g.id === c).name,
                        id: c,
                        materialsForTable: data.find(r => r.specialtyId === c)?.teamSpecialtiesMaterials || []
                    }))
                    if (data.length > 0) {
						this.items = data
						// for (let i = 0; i < this.items.length; i++){
						// 	this.specialtyIds[i] = this.items[i].specialtyId
						// 	this.quantity[i] = this.items[i].amount   
						// 	this.notes[i] = this.items[i].notes
                        //     this.workloadId[i] = this.items[i].workloadId
                        //     this.tableInputs.push({})
						// }
						this.isPreview = true

                        // for (let i = 0; i < this.items.length; i++) {
                        //     if (this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId).length !== 0) {
                        //         this.items[i].materials = this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId)[0].materialIds.map(c => ({
                        //             id: c,
                        //             name: this.materials.find(f => f.id === c)?.name
                        //         }))
                        //     } else {
                        //         this.items[i].materials = []
                        //     }
                        // }
                    } else {
                        this.isempty = true
                        // for (let i = 0; i < this.items.length; i++){
						// 	this.materialIds[i] = null
						// 	this.specialtyIds[i] = this.items[i].specialtyId
						// 	this.quantity[i] = null   
						// 	this.notes[i] = null
                        //     this.workloadId[i] = null
                        //     this.isAdd[i] = true  
						// }

                        for (let i = 0; i < team.specialtyIds.length; i++) {
                            this.items.push({
                                specialtyId: team.specialtyIds[i],
                                name: this.specialties.find(c => c.id === team.specialtyIds[i])?.name
                            }) 
                        }
                        this.items.forEach((ele) => {
                            this.specialtyIds.push(ele.specialtyId)
                        })
                        for (let i = 0; i < this.items.length; i++) {
                            if (this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId).length !== 0) {
                                this.items[i].materials = this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId)[0].materialIds.map(c => ({
                                    id: c,
                                    name: this.materials.find(f => f.id === c)?.name
                                }))
                            } else {
                                this.items[i].materials = []
                            }
                        }
                    }
                }).catch(() => {
                    this.loading = false
                })
            }).finally(() => {
                this.loading = false              
            })
        },

        nextMonth () {
            this.date = moment(this.date).add(1, 'month').format('YYYY-MM')
		},
		prevMonth () {
            this.date = moment(this.date).subtract(1, 'month').format('YYYY-MM')
		},

        addItem(index) {
            const material = {
                materialId: this.tableInputs[index].materialId,
                amount: this.tableInputs[index].amount,
                notes: this.tableInputs[index].notes,
                workloadId: this.tableInputs[index].workLoadId
            }
            this.submitLoading = true
            this.$store.dispatch('teams/createTeamMaterial', {
                teamId: this.teamId,
                specialtyId: this.items[index],
                date: moment(this.date).format('YYYY-MM-DD'),
                material: material
            }).then(() => {
                this.getTeamById()
            }).finally(() => {
                this.submitLoading = false
            })
        },

        editItem() {
            
        },

        deleteItem (id) {
            this.loading = true
            this.$store.dispatch('materials/deleteTeamSpecialtyMaterial', { id: id }).then(() => {
                this.getTeamById().then(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
            })
        }

        // setTableRef(el, specialtyId) {
        //     if (el) {
        //         this.tableRefs[specialtyId] = el
        //     }
        // },
    },

    created () {
        this.loading = true
        Promise.all([
            !this.myMaterials.length ? this.$store.dispatch('materials/fetchMyMaterial', { 
				employeeId: this.employeeId,
				withPrices: false
			}) : null,

            !this.teams.length ? this.$store.dispatch('teams/fetchAll') : null,
            
            !this.specialties.length ? this.$requestStack.setRequest({
                key: 'specialties/fetchAll',
                promise: this.$store.dispatch('specialties/fetchAll'),
            }) : this.$requestStack.getRequest('specialties/fetchAll').promise,
            
            !this.materials.length ? this.$requestStack.setRequest({
                key: 'materials/fetchAll',
                promise: this.$store.dispatch('materials/fetchAll', true)
            }) : this.$requestStack.getRequest('materials/fetchAll').promise,

            !this.staff.length ? this.$requestStack.setRequest({
                key: 'accounts/fetchAllBrief/2',
                promise: this.$store.dispatch('accounts/fetchAllBrief', { type: 0, includeAddress: true, regionIds: [] }),
            }) : this.$requestStack.getRequest('accounts/fetchAllBrief/2').promise,
            
            !this.classification.length ? this.$requestStack.setRequest({
                key: 'workload/fetchAll',
                promise: this.$store.dispatch('workload/fetchAll'),
            }) : this.$requestStack.getRequest('workload/fetchAll').promise,
        ]).finally(() => {
            this.loading = false
        })
    }
}
</script>
